module.exports = __webpack_public_path__ + "static/media/in-fill (1)@2x.a1acb42c.svg";